import { render, staticRenderFns } from "./chat-messages.vue?vue&type=template&id=70d84823&scoped=true"
import script from "./chat-messages.vue?vue&type=script&lang=js"
export * from "./chat-messages.vue?vue&type=script&lang=js"
import style0 from "./chat-messages.vue?vue&type=style&index=0&id=70d84823&prod&lang=less"
import style1 from "./chat-messages.vue?vue&type=style&index=1&id=70d84823&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d84823",
  null
  
)

export default component.exports